module.exports = __webpack_public_path__ + "img/sort_up.0e86c5d3.png";